module.exports = __webpack_public_path__ + "76df39094b53dfe46af92f311f7e10ff.woff2";